export default __webpack_public_path__ + "static/notebook-3-f0258c6e02e31cc3f04602ecf544390c.jpeg";